<template>
  <div class="db-row">
    <span class="db-row__title">{{ value.name }}</span>
    <span class="db-row__count">{{ db_count_by_range }}</span>
    <poptip
      v-if="need_show_range"
      width="400"
      trigger="click"
      placement="right"
      :title="value.name"
    >
      <tooltip
        placement="top"
        min-width="500"
        max-width="500"
        theme="light"
        :content="$t('mailer.tooltips.db_range')"
      >
        <!-- a href="#" class="db-row__settings" @click.prevent>&nbsp;</a -->
        <icon type="ios-settings-outline" size="22" />
      </tooltip>

      <template slot="content">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <slider
                :value="value.range"
                :range="true"
                :min="get_min"
                :max="get_max"
                show-tip="never"
                :show-stops="show_slider_breakpoint"
                :disabled="is_only_one_phone"
                @on-change="on_change"
              />
            </div>
          </div>
          <div class="row justify-content-between">
            <span class="col" style="padding-left: 10px">{{ get_min }}</span>
            <span class="col text-right" style="padding-right: 10px">
              {{ value.recipients_count }}
            </span>
          </div>
          <range-input
            :recipients_count="value.recipients_count"
            :range="value.range"
            @range:update="range_update"
          />
        </div>
      </template>
    </poptip>
  </div>
</template>

<script>
  import RangeInput from './input-recipients-range-input';

  export default {
    components: { RangeInput },
    props: {
      value: {
        type: Object,
        default: () => ({})
      },
      need_show_range: {
        type: Boolean,
        default: true
      },
      range_from_one: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      get_min() {
        return this.range_from_one ? 1 : 0;
      },
      get_max() {
        return this.value.recipients_count;
      },
      show_slider_breakpoint() {
        return this.value.recipients_count < 10;
      },
      db_count_by_range() {
        if (this.range_from_one) {
          return this.value.range[1] - this.value.range[0] + 1;
        }
        return this.value.range[1] - this.value.range[0];
      },
      is_only_one_phone() {
        return this.value.recipients_count === 1;
      }
    },
    methods: {
      range_update(range) {
        this.$emit('input', range);
      },
      on_change(e) {
        let [start, end] = e;
        if (start >= this.value.recipients_count) {
          start = this.value.recipients_count - 1;
        }

        if (end <= 0) {
          end = 1;
        }
        this.range_update([start, end]);
      }
    }
  };
</script>

<style lang="scss">
  .db-row {
    display: flex;
    justify-content: space-between;
    padding: $spacer/2 $spacer;
    transition: all 0.3s;
    position: relative;

    &:hover {
      background: $grey-light;
      cursor: pointer;

      .db-row__settings {
        opacity: 1;
      }
    }

    &__count,
    &__title {
      flex: 1 0 auto;
    }

    &__count {
      text-align: right;
    }

    .ivu-poptip-rel {
      position: absolute;
      right: -36px;
      top: 1px;
      height: 32px;
      width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__settings {
      width: 100%;
      height: 100%;
      display: inline-block;
      background-image: url('/img/icons/table-controls/config.svg');
      background-repeat: no-repeat;
      background-position: center;
      //opacity: 0;
      transition: opacity 0.3s;

      &:hover {
        text-decoration: none;
      }
    }
    &__row-input-delimeter {
      margin-left: 6px;
      margin-right: 6px;
    }
    .ivu-slider-stop {
      position: absolute;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transform: translateY(-3px) translateX(-50%);
      border: 2px solid #57a3f3;
      background-color: #57a3f3;
    }
  }

  .db-row-info .ivu-poptip-rel {
    position: absolute;
    right: -31px;
    top: 0;
    height: 31px;
    width: 31px;

    .settings-db {
      position: relative;
      right: 0;
      top: 2px;
      width: 31px;
    }
  }
</style>
